goog.provide('el8.appchart.letters.form');

goog.require('el8.app.shared.clickItemOpts');
goog.require('el8.appservice.notifier');
goog.require('el8.appshared.dialog.inviteToPassport');
goog.require('el8.appshared.mindreaderOpts');
goog.require('el8.data.imos');
goog.require('el8.ptdata.ptProblems');
goog.require('el8.service.urls');
goog.require('el8.template.uiwidget.Icd10ListEditor');
goog.require('el8.uiwidget.alert');
goog.require('el8.uiwidget.Form');
goog.require('el8.uiwidget.Icd10ListEditor');
goog.require('el8.uiwidget.NewActionsMenu');
goog.require('el8.util.amplitude.letterHelpers');
goog.require('el8.util.consts');
goog.require('el8.util.string');
goog.require('el8.util.validate');


/**
 * This is the form used by the letter pane - this file manages
 * creating the form itself plus the buttons bound to the form and
 * their click functions.
 */
el8.appchart.letters.form = (function() {
    var container = $('#third-pane-container');

    return {
        create: function(opts) {
            var isSendToPatient = opts['isSendToPatient'];
            var newContactCb = opts['newContactCb'];
            var deleteLetterFn = opts['deleteLetterFn'];
            var isReferralLetter = opts['isReferralLetter'];
            var unreadAlertInDaysChangeFn = opts['unreadAlertInDaysChangeFn'];
            var allowSigning = opts['allowSigning'];

            var fields = [];

            // consultant specific fields
            if (!isSendToPatient) {
                fields = [
                    {
                        name: 'toField',
                        selector: '.to-field-input',
                        infoText: 'enter a name or fax number...',
                        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                        validate: {
                            required: true
                        },
                        clickItemOpts: $.extend(el8.app.shared.clickItemOpts.detailedPhysicians({
                            urlParams: { nolocal: 1 },
                            newContactCb: newContactCb
                        }), {
                            maxLength: 200,
                            changeFn: function(item) {
                                if (item) {
                                    if (el8Globals.FEATURES.PLR4Everyone) {
                                        $('.add-to-main-providers-section', container).hide();

                                        if (el8.ptdata.careTeamProviders.canCurrentUserGrantAccess()) {
                                            $('.add-to-care-team-section', container).show();
                                        } else {
                                            $('.add-to-care-team-section', container).hide();
                                        }
                                    } else {
                                        $('.add-to-main-providers-section', container).show();
                                        $('.add-to-care-team-section', container).hide();
                                    }
                                    if (item.id) {
                                        form.setVal('addToMainProviders', true);
                                        if (el8.appchart.letters.faxGuide.isInProgress()) {
                                            $(document).trigger('letter-chose-contact');
                                        }

                                        // Generally this is already available, but make sure
                                        el8.ptdata.ptProviders.softLoad();
                                        if (el8Globals.FEATURES.PLR4Everyone) {
                                            el8.ptdata.careTeamProviders.softLoad();
                                        }

                                        // If this physician is already on our main team or
                                        // in our enterprise, disable the checkbox, because unchecking
                                        // it won't really keep them off our team...
                                        var contact = el8.data.physicians.getById(item.id);
                                        var ptProvider = el8.ptdata.ptProviders.getByPhysicianId(item.id);

                                        var onMainTeam = (ptProvider && ptProvider.getGroup() === 'main');
                                        var inSameEnterprise = (el8.data.currPractice.getEnterpriseId() &&
                                            el8.data.currPractice.getEnterpriseId() === contact.getAccessEnterpriseId());

                                        var $labelText = form.getInputField('addToMainProviders').siblings('.label-text');
                                        if (onMainTeam || inSameEnterprise) {
                                            form.disableField('addToMainProviders');
                                            // Also, if this person is in our enterprise but not yet
                                            // a collaborator, let the user know that they will be
                                            // after this letter is sent
                                            if (el8Globals.FEATURES.PLR && inSameEnterprise &&
                                                !el8.ptdata.plrCollaborators.getByPracticeId(contact.getAccessPracticeId())) {

                                                $labelText.text('Add this ' +
                                                    el8.data.currPractice.getEnterpriseName() + ' provider as a collaborator');
                                            }
                                        } else {
                                            form.enableField('addToMainProviders');
                                            $labelText.text('Add to Provider List');
                                        }

                                        if (el8Globals.FEATURES.PLR4Everyone) {
                                            if (contact && el8.ptdata.careTeamProviders.isUserActive(contact.getAccessUserId())) {
                                                form.disableField('addToCareTeam');
                                                form.setVal('addToCareTeam', true);
                                                el8.appchart.letters.main.updatePlrSharingPrompt();
                                            }
                                            else if (contact.isAccessPracticePlr() || contact.isAccessPracticePracticingEmr()) {
                                                form.enableField('addToCareTeam');
                                            } else {
                                                $('.add-to-care-team-section', container).hide();
                                                form.setVal('addToCareTeam', false);
                                            }
                                        }
                                    }
                                } else {
                                    $('.add-to-main-providers-section', container).hide();
                                    $('.add-to-care-team-section', container).hide();
                                }
                            }
                        })
                    },
                    {
                        name: 'addToMainProviders',
                        selector: ':input[name="addToMainProviders"]'
                    },
                    {
                        name: 'addToCareTeam',
                        selector: ':input[name="addToCareTeam"]'
                    }
                ];
            }

            if (isReferralLetter) {
                fields = fields.concat([
                    {
                        name: 'authorizationFor',
                        selector: ':input[name="authorizationFor"]'
                    },
                    {
                        name: 'authNumber',
                        selector: ':input[name="authNumber"]',
                        height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                        infoText: 'referral authorization number...',
                        maxLength: 20
                    },
                    {
                        name: 'dxs-le',
                        selector: '.billing-dxs-container',
                        // Note: the "show dual coding" checkbox is shown and managed by the widget by default
                        icd10ListeditorOpts: {
                            onImoSelectFn: function(icd10Le, item, mleIndex) {
                                if (item.imo_code) {
                                    var imo = el8.data.imos.getByKey(item.imo_code);
                                    imo.getAsBillDxMaps().forEach(function(dxMap) {
                                        icd10Le.addNewEntry(dxMap);
                                    });
                                } else if (item.model_class === 'ICD10Code') {
                                    var icd10 = el8.data.icd10Codes.create(item);
                                    icd10Le.addNewEntry({
                                        icd10Code: icd10.asSoyMap()
                                    });
                                }
                            },
                            index: null // only one LE
                        }
                    },
                    {
                        name: 'onBehalfOf',
                        selector: ':input[name="onBehalfOf"]'
                    }
                ]);
            }

            // present in both
            fields = fields.concat([
                {
                    name: 'subject',
                    selector: ':input[name="subject"]',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT,
                    maxLength: 200
                },
                {
                    name: 'body',
                    selector: ':input[name="body"]',
                    height: el8.util.consts.DEFAULT_FIELD_HEIGHT*10
                    // leaving out maxLength: text field
                },
                {
                    name: 'deliveryDate',
                    selector: ':input[name="deliveryDate"]',
                    infoText: 'date...',
                    datePickerOpts: {}
                    // not validating here b/c we don't want the field to turn
                    // red if both it and the recipient are left blank
                },
                {
                    name: 'unreadAlertInDays',
                    selector: ':input[name="unreadAlertInDays"]',
                    changeFn: function() {
                        unreadAlertInDaysChangeFn();
                    }
                },
                {
                    name: 'unreadAlertDate',
                    selector: ':input[name="unreadAlertDate"]',
                    infoText: 'date...',
                    datePickerOpts: {}
                },
                {
                    name: 'printHeaderId',
                    selector: ':input[name="printHeaderId"]'
                }
            ]);

            var form = new el8.uiwidget.Form({
                fields: fields,
                container: $('#letter-form', container),
                buttonElt: $('#letter-buttons', container),
                validationOpts: el8.util.validate.standardOpts
            });

            if (allowSigning) {
                if (isSendToPatient) {
                    form.addButton('sign-primary', 'Sign & Send', function(_form, $button) {
                        signPtLetterFn(_form, { ampAction: $button.text() });
                    }, true);
                } else if (isReferralLetter) {
                    form.addButton('sign-primary', 'Sign, Send & Print Pt Copy', function(_form, $button) {
                        // if there is a deliveryDate, don't print a patient copy
                        signProvLetterFn(_form, {
                            printPtCopy: !Boolean(_form.getVal('deliveryDate')),
                            ampAction: $button.text()
                        });
                    }, true);
                } else {
                    form.addButton('sign-primary', 'Sign & Send', function(_form, $button) {
                        // if there is a deliveryDate, don't print a patient copy
                        signProvLetterFn(_form, { ampAction: $button.text() });
                    }, true);
                }
                var actionsMenu = new el8.uiwidget.NewActionsMenu({
                    container: $('.button-section', container),
                    anchorTop: $('#letter-buttons'),
                    menuId: 'letter-sign-menu',
                    width: 250
                });
                form.addButton('sign-dropdown', 'Sign & More', function(_form, $btn) {
                    var signMenu = getSignActionMenu(form, isSendToPatient, isReferralLetter);
                    var topOffset = -31 - 25*(signMenu.length-1);
                    actionsMenu.display($btn, null, {top: topOffset, left: 170}, signMenu);
                    return false;
                }, false, false, true); // isPrimary, isSubmit, isDropdown
            }

            form.addButton('save-draft', 'Save as Draft & Close', el8.appchart.letters.main.close);
            form.addButton('print-preview', 'Preview', printPreviewFn, false, false, false, true);
            form.addDiscardButton(function(_form) {
                discardFn(deleteLetterFn);
            });

            addOptionCheckboxFns(form);

            return form;
        },

        // update captions and enabled/disabled state as appropriate
        updateButtons: function(form, curLetter) {
            var deliveryType = el8.appchart.letters.main.getDeliveryType();

            // Variable to keep track of if the sign-primary gets disabled
            // We do this so that we don't accidentally re-enable it in subsequent code
            var signPrimaryPreviouslyDisabled = false;

            // is this letter sendable, or just printable? (contact details or not)
            if (curLetter.isSendToPatient() || (deliveryType && deliveryType !== 'printed')) {
                form.enableButton('sign-primary');
            } else {
                form.disableButton('sign-primary');
                signPrimaryPreviouslyDisabled = true;
            }

            if (curLetter.isReferralLetter()) {
                var shouldBeEnabled;

                if (el8.data.currUser.isOfficeStaff()) {
                    var behalfPhysicianId = parseInt($('.behalf-physicians', container).val());
                    var referralDelegatingPhysIds = el8.data.currUser.getDelegatingPhysicianIdsMap().referrals;

                    shouldBeEnabled = referralDelegatingPhysIds && referralDelegatingPhysIds.length > 0 && referralDelegatingPhysIds.includes(behalfPhysicianId);
                } else {
                    shouldBeEnabled = true;
                }

                if (shouldBeEnabled) {
                    // Only enable the primary button if it hasn't been disabled by other means already
                    if (!signPrimaryPreviouslyDisabled) {
                        form.enableButton('sign-primary');
                    }
                    form.enableButton('sign-dropdown');
                } else {
                    form.disableButton('sign-primary');
                    form.disableButton('sign-dropdown');
                }
            }

            // is this letter post-dated?
            if (curLetter.getDeliveryDate()) {
                form.updateButtonCaption('sign-primary', 'Sign & Schedule');
            } else {
                if (curLetter.isReferralLetter()) {
                    form.updateButtonCaption('sign-primary', 'Sign, Send & Print Pt Copy');
                } else {
                    form.updateButtonCaption('sign-primary', 'Sign & Send');
                }
            }
        },

        populatePrintHeaders: function($content) {
            var headers = el8.data.printHeaders.allAsSoyMaps();
            var $headersSection = $('.print-headers-section', $content);
            if (headers.length) {
                $headersSection.html(el8.template.appchart.letters.headersList({
                    headers: headers,
                    selectedHeaderId: el8.data.currUser.getPrimaryPrintHeaderId()
                })).show();
            }
        }
    };


    /**
     * Top-level button click handlers
     */
    function discardFn(deleteLetterFn) {
        el8.uiwidget.confirm(
            'Are you sure you want to discard this letter?',
            deleteLetterFn
        );
    }

    function printPreviewFn() {
        var curLetter = el8.appchart.letters.main.extractLetter();
        window.open(el8.service.urls.get('printLetter', [curLetter]));
    }

    function signProvLetterFn(form, opts) {
        opts = opts || {};
        var deliveryType = el8.appchart.letters.main.getDeliveryType();
        switch (deliveryType) {
            case 'passport':
            case 'emr':
            case 'direct':
            case 'email':
                signAndSendFn(form, opts);
                break;
            case 'fax':
                signAndFaxFn(form, opts);
                break;
        }
    }


    function signAndSendFn(form, opts) {
        opts = opts || {};
        var curLetter = el8.appchart.letters.main.extractLetter();

        var validate = defaultValidationFn;

        if (!validate(form, curLetter)) { return; }
        form.disable(); // don't need to re-enable on sign, because then we destroy the form
        el8.appchart.letters.main.signLetter({
            async: !opts.printPtCopy,
            draftReminder: opts.draftReminder,
            callbackFn: function() {
                el8.appservice.notifier.notify(getSignedNotifier(curLetter, 'sent'));
                if (opts.printPtCopy) { window.open(el8.service.urls.get('printLetterPtCopy', [curLetter])); }

                // log in amplitude that letter was completed
                el8.util.amplitude.logCompleteLetter(opts.ampAction, el8.appchart.letters.main.getCurrentLetter());
            },
            extraArgs: { send_out: true }
        });
    }

    function signAndFaxFn(form, opts) {
        opts = opts || {};
        var curLetter = el8.appchart.letters.main.extractLetter();

        var _sendFaxFn = function() {
            form.disable(); // don't need to re-enable on sign, because then we destroy the form
            el8.appchart.letters.main.signLetter({
                async: !opts.printPtCopy,
                draftReminder: opts.draftReminder,
                callbackFn: function() {
                    el8.appservice.notifier.notify(getSignedNotifier(curLetter, 'faxed'));
                    if (opts.printPtCopy) { window.open(el8.service.urls.get('printLetterPtCopy', [curLetter])); }
                },
                extraArgs: { send_out: true }
            });
        };
        var validate = function(form) {
            if (!defaultValidationFn(form)) { return false; }
            if (!curLetter.getToNumber()) {
                el8.uiwidget.alert('Please select a contact with a fax number to enable Sign & Fax');
                return false;
            }
            var cleanNum = el8.util.string.cleanPhoneNum(curLetter.getToNumber());
            if (cleanNum.length < 10) {
                el8.uiwidget.alert("Please change this contact's fax number to a 10-digit number.");
                return false;
            }
            var toFieldItem = form.getClickItemSelected('toField');
            var maxPages = el8.util.consts.EL8_HI_FAX_PAGES;
            if (el8.appchart.letters.main.getPageCount() > maxPages &&
                (!curLetter.getSendToContactId() || toFieldItem.contact_type === el8.util.consts.MEDICAL_GROUP_TYPE)) {
                    el8.uiwidget.alert('Please reduce the number of pages to '+maxPages+' pages or print this letter.');
                    return false;
            }
            return true;
        };

        if (!validate(form, curLetter)) { return; }
        _sendFaxFn();
    }

    function signAndPrintFn(form, opts) {
        opts = opts || {};
        var curLetter = el8.appchart.letters.main.extractLetter();

        var validate = defaultValidationFn;

        if (!validate(form, curLetter)) { return; }
        form.disable(); // don't need to re-enable on sign, because then we destroy the form
        el8.appchart.letters.main.signLetter({
            async: false,
            draftReminder: opts.draftReminder
        }); // synchronous sign so window.open doesn't create a new tab

        if (opts.printPtCopy) {
            window.open(el8.service.urls.get('printLetterPtCopy', [curLetter]));
        } else {
            window.open(el8.service.urls.get('printLetter', [curLetter]));
        }

        // log in amplitude that letter was completed
        el8.util.amplitude.logCompleteLetter(opts.ampAction, curLetter);
    }

    function signOnlyFn(form, opts) {
        opts = opts || {};
        var curLetter = el8.appchart.letters.main.extractLetter();

        var validate = defaultValidationFn;

        if (!validate(form, curLetter)) { return; }
        form.disable(); // don't need to re-enable on sign, because then we destroy the form
        el8.appchart.letters.main.signLetter(
            {
                callbackFn: function() {
                    // log in amplitude that letter was completed
                    el8.util.amplitude.logCompleteLetter(opts.ampAction, el8.appchart.letters.main.extractLetter());
                }
            }
        );

        // log in amplitude that letter was completed
        el8.util.amplitude.logCompleteLetter(opts.ampAction, el8.appchart.letters.main.extractLetter());
    }

    function signPtLetterFn(form, opts) {
        opts = opts || {};
        var curLetter = el8.appchart.letters.main.extractLetter();

        var validate = defaultValidationFn;
        var signAndClose = function() {
            el8.appchart.letters.main.signLetter({
                draftReminder: opts.draftReminder,
                callbackFn: function() {
                    el8.appservice.notifier.notify(getSignedNotifier(curLetter, 'sent to the patient'));

                    // log in amplitude that letter was completed
                    el8.util.amplitude.logCompleteLetter(opts.ampAction, curLetter);
                }
            });
        };

        if (!validate(form, curLetter)) { return; }
        form.disable(); // don't need to re-enable on sign, because then we destroy the form

        // show the passport invite dialog before sending, if the user hasn't been invited
        el8.appshared.dialog.inviteToPassport.showAsNeeded({
            successCb: signAndClose,
            dismissCb: function() { form.enable(); },
            fromLetter: true
        });


    }

    function defaultValidationFn(form, curLetter) {
        if (!form.isValid() && !curLetter.isSendToPatient()) {
            // don't need to check recipient field for patient letters
            el8.uiwidget.alert('Please enter a recipient.');
            return false;
        }
        var deliveryDate = el8.util.datecompare.dateFromStr(form.getVal('deliveryDate'));
        if (deliveryDate && !el8.util.datecompare.isTodayOrAfter(deliveryDate)) {
            el8.uiwidget.alert('Post Date must be a date in the future or blank');
            return false;
        }
        return true;
    }

    function getSignActionMenu(form, isSendToPatient, isReferralLetter) {
        var menu = [];
        var isPostDated = Boolean(form.getVal('deliveryDate'));
        var pageCount = el8.appchart.letters.main.getPageCount();
        var sendButtonDisabled = form.getButtonSet().getButtonElts()[0].is(':disabled');
        var bigLetter = (pageCount > el8.util.consts.EL8_HI_FAX_PAGES);

        var getStyledText = function(text, disable) {
            return '<span' + (disable ? ' class="disabled">' : '>') +
                text + '</span>';
        };

        // Patient Letters
        if (isSendToPatient) {
            var patientUninvited = (el8.ptdata.ptRegistrationInfo.getInviteStatus() === 'NOT_INVITED');
            var signAndPrintText;

            if (patientUninvited) {
                signAndPrintText = 'Sign & Print';
            } else if (isPostDated) {
                signAndPrintText = 'Sign, Schedule & Print';
            } else {
                signAndPrintText = 'Sign, Send & Print';
            }
            menu.push({
                actionText: signAndPrintText,
                actionFn: function(item, $actionItem) {
                    signAndPrintFn(form, { ampAction: $actionItem.text() });
                }
            });

            if (!isPostDated) {
                menu.push({
                    actionSafeText: getStyledText('Sign, Send & Create Follow-up Letter', patientUninvited),
                    actionFn: function(item, $actionItem) {
                        if (patientUninvited) { return; }
                        signPtLetterFn(form, {
                            draftReminder: true,
                            ampAction: $actionItem.text()
                        });
                    }
                });
            }
        // Provider Letters
        } else {
            // Post-dated
            if (isPostDated) {
                menu.push({
                    actionSafeText: getStyledText('Sign, Schedule, & Print Pt Copy', sendButtonDisabled),
                    actionFn: function(item, $actionItem) {
                        if (sendButtonDisabled) { return; }
                        signProvLetterFn(form, {
                            printPtCopy: true,
                            ampAction: $actionItem.text()
                        });
                    }
                });
                menu.push({
                    actionSafeText: getStyledText('Sign, Schedule, & Print w/ Attachments', sendButtonDisabled || bigLetter),
                    actionFn: function(item, $actionItem) {
                        if (sendButtonDisabled || bigLetter) { return; }
                        signAndPrintFn(form, { ampAction: $actionItem.text() });
                    }
                });
            // Regular
            } else {
                if (isReferralLetter) {
                    menu.push({
                        actionSafeText: getStyledText('Sign & Send', sendButtonDisabled),
                        actionFn: function(item, $actionItem) {
                            if (sendButtonDisabled) { return; }
                            signProvLetterFn(form, { ampAction: $actionItem.text() });
                        }
                    });
                    menu.push({
                        actionText: 'Sign & Print Referral Only (Pt Copy)',
                        actionFn: function(item, $actionItem) {
                            signAndPrintFn(form, {
                                printPtCopy: true,
                                ampAction: $actionItem.text()
                            });
                        }
                    });
                } else {
                    menu.push({
                        actionSafeText: getStyledText('Sign, Send & Print Pt Copy', sendButtonDisabled),
                        actionFn: function(item, $actionItem) {
                            if (sendButtonDisabled) { return; }
                            signProvLetterFn(form, {
                                printPtCopy: true,
                                ampAction: $actionItem.text()
                            });
                        }
                    });
                }


                if (bigLetter) {
                    menu.push({
                        // ok to sign without recipient contact info
                        actionText: 'Sign & Download PDF',
                        actionFn: function(item, $actionItem) {
                            el8.appservice.notifier.notify('You will be notified when the letter is ready to download.');
                            signOnlyFn(form, { ampAction: $actionItem.text() });
                        }
                    });
                } else {
                    var printWithAttachButtonCopy = isReferralLetter ? 'Sign & Print Referral & Attachments' : 'Sign & Print w/ Attachments';
                    menu.push({
                        // ok to sign without recipient contact info
                        actionText: printWithAttachButtonCopy,
                        actionFn: function(item, $actionItem) {
                            signAndPrintFn(form, { ampAction: $actionItem.text() });
                        }
                    });
                }
                menu.push({
                    actionSafeText: getStyledText('Sign, Send & Create Follow-up Letter', sendButtonDisabled),
                    actionFn: function(item, $actionItem) {
                        if (sendButtonDisabled) { return; }
                        signProvLetterFn(form, {
                            draftReminder: true,
                            ampAction: $actionItem.text()
                        });
                    }
                });
            }
        }

        return menu;
    }

    // methodDescription finishes the sentence "Your letter is being..."
    function getSignedNotifier(curLetter, methodDescription) {
        if (curLetter.getDeliveryDate()) {
            return 'Your letter will be sent on ' + curLetter.getDeliveryDate().asString();
        }
        return 'Your letter is being ' + methodDescription + '.';
    }

    /**
     * Unfortunately, checkboxes in the optionspane right above the buttons cannot live
     * inside the "form" HTML element. So we manage them manually and give them
     * separate function calls.
     */
    function addOptionCheckboxFns(form) {
        form.getOptionCheckboxVal = function(name) {
            return $('input:checkbox[name="'+name+'"]', container).is(':checked');
        };
        form.setOptionCheckboxVal = function(name, val) {
            if (val) {
                $('input:checkbox[name="'+name+'"]', container).prop('checked', true);
            } else {
                $('input:checkbox[name="'+name+'"]', container).prop('checked', false);
            }
        };

        form.disableOptionCheckbox = function(name) {
            var $input = $('input:checkbox[name="'+name+'"]', container);
            $input.prop('disabled', true);
            $input.closest('label').addClass('el8ItemDisable');
        };
        form.enableOptionCheckbox = function(name) {
            var $input = $('input:checkbox[name="'+name+'"]', container);
            $input.prop('disabled', false);
            $input.closest('label').removeClass('el8ItemDisable');
        };
    }
})();
